import React, { useEffect } from "react";
import { ManageStockBasePage } from "../..";
import { useRenaveContext } from "../../../../hooks";
import { RenaveMenuStepsEnum } from "../../../../models";
import { CheckInDanfeOrganism } from "../../../organisms";

export const CheckInDanfePage: React.FC = () => {
  const {
    menuCurrentStepContext,
    menuSelectedStepContext,
    setMenuSelectedStepContext,
  } = useRenaveContext();

  useEffect(() => {
    setMenuSelectedStepContext(RenaveMenuStepsEnum.CheckInDanfe);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ManageStockBasePage>
      <CheckInDanfeOrganism
        viewMode={menuSelectedStepContext < menuCurrentStepContext}
      />
    </ManageStockBasePage>
  );
};
